import { render, staticRenderFns } from "./chooseCoupon.vue?vue&type=template&id=c84b921a"
import script from "./chooseCoupon.vue?vue&type=script&lang=js"
export * from "./chooseCoupon.vue?vue&type=script&lang=js"
import style0 from "./chooseCoupon.vue?vue&type=style&index=0&id=c84b921a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports